module.exports = "https://p.cds.unp.clasificados.pe/roboto-regular.e237166b711fd1d4ac0f5684faecc85f.woff2";